import script from "./CadastroTipoFoto.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroTipoFoto.vue?vue&type=script&setup=true&lang=js"

import "./CadastroTipoFoto.vue?vue&type=style&index=0&id=59e2b694&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59e2b694"]])

export default __exports__